import * as DictionaryConstants from '../../../../../constants/DictionaryConstants'
import * as RoutePathConstants from '../../../../../constants/RoutePathConstants'
import { mapActions, mapState } from 'vuex'
// import dateUtils from '../../../../common/utils/dateUtil'
import moment from 'moment'

export default {
  data () {
    return {
      pageNum: 1,
      pageSize: 10,
      pageOrder: 'desc',
      pageSort: 'id',
      centerHeight: document.documentElement.clientHeight - 130 + 'px',
      type: '',
      activeIndex: '1'
    }
  },
  computed: {
    ...mapState('recordsOfConsumptionModule', ['myMemberConsumption']),
    myMemberConsumptionInfo () {
      return (this.myMemberConsumption || []).filter(it => {
        return it.reservationType == 1000 || it.reservationType == 2000 || it.reservationType == 3000
      })
    }
  },
  methods: {
    ...mapActions('recordsOfConsumptionModule', ['getMemberConsumption']),
    dateFormat (time) {
      return time ? moment(time).format('YYYY-MM-DD HH:mm') : ''
    },
    handleSelect (key, keyPath) {
      this.getMemberConsumptionInfo(key + '')
    },
    getMemberConsumptionInfo (type) {
      if (type) {
        this.type = type
      }
      let pageData = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        pageSort: this.pageSort,
        pageOrder: this.pageOrder,
      }
      if (this.type && this.type !== '0') {
        pageData.reservationType = type * 1
      }
      if (type == 1) {
        pageData = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          pageSort: this.pageSort,
          pageOrder: this.pageOrder,
        }
      }
      this.getMemberConsumption(pageData)
    },
    load () {
      this.pageSize += 10
      this.getMemberConsumptionInfo(this.type)
    },
    goToDetails (item) {
      this.$router.push({
        path: RoutePathConstants.CONSUMPTION_INFO,
        query: {
          info: item
        }
      })
    }
  },
  mounted () {
    this.getMemberConsumptionInfo()
    document.title = '预约记录'
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/records-of-consumption/views/records-of-consumption.js